import { ProgramDto } from "common/models";
import useLocationState from "ui/router/hooks/useLocationState";
import ProgramDetails from "ui/programs/components/display/ProgramDetails/ProgramDetails";
import BasePage from "ui/common/components/layout/BasePage/BasePage";

function ProgramDetailsPage() {
    const program = useLocationState<ProgramDto>("program");
    return (
        <BasePage>
            <ProgramDetails program={program} />
        </BasePage>
    );
}

export default ProgramDetailsPage;
